import Vue from 'vue'
import flatMap from 'lodash-es/flatMap'
import { createApp } from '@/vue/app.js'
import FusedHeaderNav from '@/vue/components/fused/header_nav.vue'
import FusedOffCanvasNav from '@/vue/components/fused/off_canvas_nav.vue'
import VueEventBus from '@/vue/vue_event_bus'
import Modal from '@/components/modal.vue'
import _get from 'lodash-es/get'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

// Globally used Vue functionality
Vue.prototype.$VueEventBus = VueEventBus

if (global.Stage) {
  const ignoreExceptionRules = [
    hint =>
      _get(hint, 'originalException.stack', '').indexOf(
        'ky/distribution/errors/TimeoutError'
      ) > -1
  ]

  Sentry.init({
    dsn: 'https://0031bc710c854c758138d93ceeffb4b3@sentry.akra.systems/50',
    autoSessionTracking: false,
    environment: global.Stage,
    release: global.Release,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
        logErrors: global.Stage !== 'prod'
      })
    ],
    beforeSend(event, hint) {
      if (ignoreExceptionRules.some(rule => rule(hint))) {
        return null
      } else {
        return event
      }
    }
  })
}

// client-specific bootstrapping logic...

if (window && window.history && window.history.scrollRestoration) {
  window.history.scrollRestoration = 'manual'
}

const { app, store } = createApp(
  window.__INITIAL_STATE__ || global.VuexStore,
  global.localeI18nJs
)

app.$mount('#fsd-app', true)

const components = { FusedOffCanvasNav, FusedHeaderNav, Modal }

const mountVueComponents = () => {
  Object.entries(components).forEach(([componentName, component]) => {
    const className = `nyx-${componentName}`
    // Make sure store is ready before mounting components (mainly to cope with legacy code)
    setTimeout(() => {
      flatMap([...document.getElementsByClassName(className)], el => {
        const props = JSON.parse(el.dataset.props || '{}')
        // Don't mount an element that already belongs to a Vue instance
        if (!el.__vue__) {
          new Vue({ store, el, render: h => h(component, { props }) })
        }
      })
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  mountVueComponents()
})
